import {getMutationInfo} from "@/http/services/http-services-mutation";
import {
    activateLayer,
    addLayer,
    clearLayer,
    getActiveLayers,
    getBookmarkPresentationsByID, getLayerByName,
    getSnapLayers
} from "@/helpers/ol/ol-layer-helper";
import {checkActiveLayerInfoButtons, hideAllInfo, showLayerInfoButton} from "@/helpers/layer/info/layer-info-helper";
import {fromCircle} from "ol/geom/Polygon";
import {getBySelector, hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper";
import {
    addToolsMutationSelectLayerFeature,
    addToolsMutationSelectLayerItem,
    createToolsMutationSelectLayer, removeToolsMutationSelectLayerItem,
    updateToolsMutationSelectLayer
} from "@/helpers/tools/tools-mutation-select-layer-helper";
import {
    finishDrawing,
    isDrawActive,
    stopDraw, toggleDrawButtons,
    undoDrawGeometry
} from "@/helpers/ol/draw/ol-draw-polygon-helper";
import {addFilterSelectLayerItem} from "@/helpers/filter/filter-geometry-helper";

import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper";
import {initPopper} from "@/modules/popper";
import {finishMutationDrawing} from "@/helpers/datatable/datatable-editor-helper";
import {isCesiumEnabled} from "@/modules/cesium/cesium";
import {getFilterGeometryType} from "@/helpers/filter/filter-helper";
import {createBufferByGeometry} from "@/helpers/measure/measure-buffer-helper";
import $ from "jquery";
import Swal from "sweetalert2";
import {geMeasureLayerName} from "@/helpers/tools/tools-measure-helper";
import {getBranchItemByBookmarkPresentationID} from "@/helpers/tree-helper";
import {initDataTableSelector} from "@/helpers/datatable/datatable-selector-helper";
import {getRouteLocation} from "@/helpers/ol/ol-route-helper.js";
import toastr from "toastr";
import {reloadGeometryLayers} from "@/helpers/tools/tools-helper.js";
import {isMobile} from "@/helpers/mobile-helper.js";
import {showNotification} from "@/helpers/notification-helper.js";
import {getTemporaryLayerByIndex} from "@/helpers/layer/temporary/temporary-layer-helper.js";

const featureInfo = {}
const mutationLayerName = 'draw-mutation'
let activeBookmarkPresentationID
let mutationGeomName
let activeMutation

export function getMutationLayerName() {
    return mutationLayerName
}

export function getActiveMutation() {
    return activeMutation
}

export function initMutationLayers() {
    let options = '<option></option>'
    let list = ''
    window.mutationForms.map((mutationForm) => {
        const form = mutationForm.form
        const branchItem = getBranchItemByBookmarkPresentationID(mutationForm.BookmarkPresentationID)

        if(mutationForm.hasGeometry && branchItem.userRights.includes(5)) {

            list += `
        <tr>
            <td>
                <div data-bookmark-presentation-id="${mutationForm.BookmarkPresentationID}" data-domain-id="${mutationForm.DomainID}"  data-presentation-id="${mutationForm.PresentationID}" data-form-id="${form.ID}" class="list-group-item-action cursor-pointer">
                    ${form.Name} - ${branchItem.label}
                </div>
            </td>
        </tr>`
            options += '<option data-form-name="' + form.Name + '" data-bookmark-presentation-id="' + mutationForm.BookmarkPresentationID + '" data-domain-id="' + mutationForm.DomainID + '"  data-presentation-id="' + mutationForm.PresentationID + '" value="' + form.ID + '">' + branchItem.label + ' : ' + form.Name + '</option>'
        }
    })
    document.getElementById('slcMutationLayers').innerHTML = options

    const lstMutationLayers = document.querySelector('#tblMutationSettings tbody')
    lstMutationLayers.innerHTML = list

    initDataTableSelector('tblMutationSettings')

    lstMutationLayers.querySelectorAll('.list-group-item-action').forEach((element) => {
        element.addEventListener('click', (event) => {
            const target = event.target
            if(target.dataset.bookmarkPresentationId) {
                showElementsBySelector('layer-info-mutation .btnHideInfoMenu')
                hideElementsBySelector('#divCardMutationLayers')
                showElementsBySelector('#divMutationLayers')
                showElementsBySelector('#btnShowMutationLayers')
                setMutationSettings(target.dataset.bookmarkPresentationId, target.dataset.domainId, target.dataset.presentationId, target.dataset.formId)
            } else {
                stopDraw()
                showElementsBySelector('#divCardMutationLayers')
                getBySelector('#divToolsMutationSettings').innerHTML = ``
            }
            checkActiveLayerInfoButtons()
        })
    })
}

export function setMutationSettings(bookmarkPresentationID, domainID, presentationID, formID, branchID = undefined, showBackButton = true) {

    const bookmarkPresentationIDs = []
    if(branchID) {
        const branch = getBranchItemByBookmarkPresentationID(branchID)

        // console.log(branchItem)

        // branchItem.branch.map((branch, key) => {
            bookmarkPresentationIDs.push(parseInt(branch.ID))

                bookmarkPresentationID = branch.ID
                domainID = branch.domainID
                presentationID = branch.mutation_forms[0].PresentationID
                formID = branch.mutation_forms[0].FormID

        // })

        activeBookmarkPresentationID = bookmarkPresentationIDs[0]
        activateLayer(branch.ID)

    } else {
        bookmarkPresentationIDs.push(bookmarkPresentationID)
        activeBookmarkPresentationID = bookmarkPresentationID
        activateLayer(bookmarkPresentationID)
    }


    const divMutationLayers = document.getElementById('divMutationLayers')
    divMutationLayers.innerHTML = ''
    let selected = false
    const slcMutationLayers = document.getElementById('slcMutationLayers')

    const select = document.getElementById('slcMutationLayers');

    const target = select.options[select.selectedIndex]

    slcMutationLayers.querySelectorAll('option').forEach((element, key) => {
        const dataset = element.dataset

        element.style = 'display:none'

        if(
            (parseInt(dataset.bookmarkPresentationId) ===  parseInt(bookmarkPresentationID) &&
            parseInt(dataset.presentationId) ===  parseInt(presentationID)) ||
            bookmarkPresentationIDs.includes(parseInt(dataset.bookmarkPresentationId))
        ) {
            let active = ''

            // const mutationForm = window.mutationForms[key - 1]



            if(parseInt(formID) === parseInt(element.value)) {
                active = 'active'
                element.selected = true
                selected = true
            }
            // } else if(!selected) {
            //     active = 'active'
            //     element.selected = true
            //     selected = true
            // }

            let formName = 'test'

            element.style = ''
            divMutationLayers.innerHTML += `<li class="nav-item"><a href="#" data-domain-id="${dataset.domainId}" data-form-id="${element.value}" data-bookmark-presentation-id="${dataset.bookmarkPresentationId}" data-presentation-id="${dataset.presentationId}" data-form-id="" class="nav-link nav-link-mutation-header cursor-pointer ${active}">${dataset.formName}</a></li>`
        }
    })

    let geomType = ''
    const mutationPromise = getMutationInfo(domainID, presentationID, formID).then(result => {


        featureInfo.DomainID = domainID
        featureInfo.PresentationID = presentationID
        featureInfo.FormID = formID
        featureInfo.BookmarkPresentationID = bookmarkPresentationID
        featureInfo.attributes = result.form_attributes

        activeMutation = {}
        activeMutation.result = result
        activeMutation.featureInfo = featureInfo

        const geomAttribute = result.form_attributes.find( attribute => attribute.attribute.Type === 21)

        let options = ''

        let icon = 'fa fa-plus'
        let contourText = ''
        switch (geomAttribute.AttributeTypeID) {
            case 24: // Punt geom
                contourText = 'Selecteer een punt als contour'
                geomType = 'point'
                icon = 'far fa-circle'

                if(getRouteLocation()) {
                    const type = getBySelector('.liHomeFindAdressType.active').dataset
                    switch (type.searchType) {
                        default:
                        case "0":
                            options += `<option value="10000000">Adres locatie</option>`
                            break;
                        case "1":
                            options += `<option value="10000000">Perceel locatie</option>`
                            break;
                        case "2":
                            options += `<option value="10000000">Coördinaat locatie</option>`
                            break;
                    }
                }
                break;
            case 240: // Punt multi geom
                contourText = 'Selecteer een of meerdere punten als contour'
                geomType = 'point'
                icon = 'far fa-circle'
                break;
            case 25: // Lijn geom
                contourText = 'Selecteer een lijn als contour'
                geomType = 'LineString'
                icon = 'fa fa-slash'
                break;
            case 250: // Lijn multi geom
                contourText = 'Selecteer een of meerdere lijnen als contour'
                geomType = 'LineString'
                icon = 'fa fa-slash'
                break;
            case 26: // Vlak geom
                contourText = 'Selecteer een vlak als contour'
                geomType = 'polygon'
                icon = 'fa fa-draw-polygon'
                break;
            case 260: // Vlak multi geom
                contourText = 'Selecteer een of meerdere vlakken als contour'
                geomType = 'polygon'
                icon = 'fa fa-draw-polygon'
                break;
        }

        mutationGeomName = geomAttribute.Attribute

        getActiveLayers().map(layer => {

            console.log(layer)

            if(layer && layer.Type === 'WMS') {
                options += `<option value="${layer.ID}">${layer.DisplayName}</option>`
            } else if(typeof layer === 'string' && layer?.includes('temporary')) {
                const temporaryLayer = getTemporaryLayerByIndex(layer)
                console.log(temporaryLayer)
                options += `<option value="${layer}">${temporaryLayer.Name}</option>`
            }
        })

        const divToolsMutationSettings = document.getElementById('divToolsMutationSettings')
        divToolsMutationSettings.innerHTML = `
            <div class="card ml-2 mt-2 mr-2 mb-1">
                <div class="card-header p-2">
                    Teken <layout-language data-key="${geomType}"></layout-language>
                    <div class="float-right d-none">
                        <layer-info-info-mutation-standalone-edit-geometry-save></layer-info-info-mutation-standalone-edit-geometry-save>
                        <layer-info-info-mutation-standalone-edit-geometry-cancel></layer-info-info-mutation-standalone-edit-geometry-cancel>
                    </div>
                </div>
                <div class="pb-2 pt-2" style="">
                  <div class="card-body pl-2">
                    <div class="row d-none" id="divDrawIn3DNotification">
                        <div class="col-12">
                            <div class="alert alert-secondary alert-dismissible fade show p-1 mb-2">
                                Tekenen in 3D is nog niet mogelijk
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                             <ol-draw-geometry data-bookmark-presentation-id="${bookmarkPresentationID}" data-draw-type="mutation" data-icon="${icon}" data-language="${geomType}"></ol-draw-geometry>
                             <ol-draw-geometry data-bookmark-presentation-id="${bookmarkPresentationID}" data-draw-type="mutation" data-icon="far fa-map" data-language="fromMap" class="mt-2 d-block"></ol-draw-geometry>
                        </div>
                        <div class="col-8">
                            <div class="row d-none mt-2" id="divMutationSnapLayer">
                                <div class="col">
                                    <select size="1" class="form-control pt-0" id="slcMutationSnapLayer">
                                        <option value="">Snap op laag</option>
                                        ${options}
                                    </select>
                                    <button id="btnMutationSnapLayer" class="btn btn-success float-right mt-2 btn-sm">
                                        <span class="fa fa-plus"></span> Opslaan
                                    </button>
                                    <button id="btnMutationUndoLayer" class="btn btn-outline-secondary popper-header btn-sm text-transform-none float-right mt-2 mr-2" href="#">
                                        <span data-type="undo" class="fa fa-undo"></span>
                                       <div class="popper-tooltip" role="tooltip" data-popper-placement="bottom" style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate(-21px, 33px);">
                                          Laatste klik ongedaan maken
                                          <div class="arrow" data-popper-arrow="" style="position: absolute; left: 0px; transform: translate(100px);"></div>
                                       </div>
                                    </button>
                                </div>
                            </div>
                          <div class="row d-none mt-2" id="divMutationSelectLayer">
                            <div class="col">
                                <select size="1" class="form-control pt-0" id="slcMutationSelectLayer">
                                    <option value="">Kies laag</option>
                                    ${options}
                                </select>
                                <div id="divMutationSelectLayer" class="d-none">
<!--                                    <div id="divMutationSelectLayerNotification" class="alert alert-secondary show p-1 mt-2 mb-0">-->
<!--                                        Selecteer een object uit de kaart-->
<!--                                    </div>-->
                                    <div id="divMutationSelectLayerItems">
                                    </div>
                                    <button id="btnMutationSelectLayer" class="btn btn-success float-right mt-2 btn-sm" disabled="disabled">
                                        <span class="fa fa-plus"></span> Opslaan
                                    </button>
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>
                      
                     
                    </div>
                </div>
            </div>
    `

        getBySelector('#slcMutationSelectLayer').addEventListener('change', event => {
            inactiveMutationGeometryButton()
            stopDraw()
            updateToolsMutationSelectLayer(event.target)
        })

        getBySelector('#btnMutationSnapLayer').addEventListener('click', event => {
            const active = isDrawActive()
            // console.log(active)
            if(isDrawActive()) {
                finishDrawing()
            } else {
                finishMutationDrawing(null)
            }
        })
        getBySelector('#btnMutationUndoLayer').addEventListener('click', event => {
            undoDrawGeometry()
        })

        getBySelector('#btnMutationSelectLayer').addEventListener('click', event => {
            createToolsMutationSelectLayer()
        })

        getBySelector('#divMutationSelectLayerItems').addEventListener('click', event => {
            removeToolsMutationSelectLayerItem(event.target.dataset.id)
            event.target.closest('.card').remove()
        })

        if(isCesiumEnabled()) {
            toggleDrawButtons()
        }
        initPopper()

        if(!showBackButton) {
            hideElementsBySelector('#btnShowMutationLayers')
        }

        reloadGeometryLayers()
    })

    Promise.all([mutationPromise, window.servicePromise]).then((values) => {

        if(window.result && window.result.mainTabs) {

            let checkedBookmarkPresentation = window.result.mainTabs.find(mainTab => mainTab.features.length > 0)
            let checkedBookmarkPresentationID
            if(checkedBookmarkPresentation) {
                checkedBookmarkPresentationID = checkedBookmarkPresentation.BookmarkPresentationID

                // Can't copy of own layer
                if(parseInt(checkedBookmarkPresentationID) !== parseInt(bookmarkPresentationID)) {
                    const mainTab = window.result.mainTabs.find(mainTab => mainTab.BookmarkPresentationID === parseInt(checkedBookmarkPresentationID))
                    if (mainTab?.features.length > 0) {
                        const feature = mainTab.features[0].feature
                        if (feature.geometry.type.toLowerCase() === geomType.toLowerCase()) {
                            // setTimeout(() => {
                                getBySelector('layer-info-mutation ol-draw-geometry[data-language="fromMap"] input').click()
                            // }, 1000)
                        } else {
                            // setTimeout(() => {
                                getBySelector('layer-info-mutation ol-draw-geometry input').click()
                            // }, 1000)
                        }
                    }
                } else {
                    getBySelector('layer-info-mutation ol-draw-geometry input').click()
                }
            }
        } else {
            // setTimeout(() => {
                getBySelector('layer-info-mutation ol-draw-geometry input').click()
            // }, 1000)
        }
    })
}

export function getMutationFeatureInfo() {
    return featureInfo
}
export function getMutationGeometryColumnByFeatureInfo(featureInfo) {
    return featureInfo.attributes.find(attribute => attribute.attribute.Type === 21)
}

export function setActiveMutation(bookmarkPresentationID, domainID, presentationID, formID, branchID = undefined, showBackButton = true) {


    showElementsBySelector('#divMutationLayers')

    getBySelector('layer-info-mutation-button').querySelector('.info-menu-btn').classList.add('active')
    hideElementsBySelector('.divMutationHelpText')

    if(isMobile()) {
        showNotification('Klik in de kaart om het te plaatsen.')
    } else {
        showLayerInfoButton('layer-info-mutation', false)
    }
    showElementsBySelector('layer-info-mutation-button')

    setMutationSettings(bookmarkPresentationID, domainID, presentationID, formID, branchID, showBackButton)

    hideElementsBySelector('#divCardMutationLayers')
    if(window.settings.ShowAllMutations === 2) {
        showElementsBySelector('#btnShowMutationLayers')
    }

    // document.getElementsByName('rdiTools')[1].click()

    // const slcMutationLayers = document.getElementById('slcMutationLayers')

    // slcMutationLayers.dispatchEvent(new Event('change'));
    // $('#slcMutationLayers').select2('data', {id: 103})
    // slcMutationLayers.val(2)
}

export function setMutationGeometryName(name) {
    mutationGeomName = name
}

export function setActiveMutationGeometry(geometry, projectionFrom = undefined, projectionTo = 'EPSG:28992', type = 'mutation') {

    if(!projectionFrom) {
        projectionFrom = getViewProjectionName()
    }

    if(!geometry) {
        clearMutationGeometry()

        return
    }


    if(geometry.getType() === 'Circle') {
        geometry = fromCircle(geometry.clone())
    }

    let flatCoordinates = geometry.flatCoordinates

    if(geometry.getType() === 'MultiPolygon') {
        flatCoordinates = []
        geometry.getPolygons().map(polygon => {
            flatCoordinates.push(polygon.transform(projectionFrom, projectionTo).getFlatCoordinates())
        })
    }

    if(geometry.getType() === 'MultiLineString') {
        flatCoordinates = []
        geometry.getLineStrings().map(polygon => {
            // console.log(polygon)
            flatCoordinates.push(polygon.transform(projectionFrom, projectionTo).getFlatCoordinates())
        })
    }

    if(type === 'filter' &&  geometry.getType() === 'Point') {
        geometry = createBufferByGeometry(geometry, 1)
        flatCoordinates = geometry.flatCoordinates
    }

    // console.log(projectionFrom)
    // console.log(projectionTo)
    if(projectionFrom !== projectionTo) {
        window.mutation_geom = geometry.transform(projectionFrom, projectionTo)
    } else {
        window.mutation_geom = geometry
    }

    window.filter_geom = flatCoordinates
    window.filter_geom_28992 = geometry
    window.mutation_geom_column = mutationGeomName
    window.filter_geom_query_type = getFilterGeometryType()
}

export function clearMutation(id) {
    if(String(id) === String(activeBookmarkPresentationID)) {
        stopDraw()
        hideAllInfo()
    }
}

function clearMutationGeometry() {
    delete window.mutation_geom
    delete window.filter_geom
    delete window.filter_geom_28992
}

export function inactiveMutationGeometryButton() {
    getBySelector('#divToolsMutationSettings').querySelector('ol-draw-geometry').querySelector('input').checked = false
}

export function mutationGeometryFromMap() {
    showElementsBySelector('#divMutationSelectLayer')
    hideElementsBySelector('#divMutationSnapLayer')

    const routeLocation = getRouteLocation()

    if(routeLocation) {
        const id = "10000000"

        if(getBySelector('#divToolsMutationSettings ol-draw-geometry').dataset.language === 'point') {

            getBySelector('#divMutationSelectLayerItems').innerHTML +=
                `<div class="card card-hover-secondary mt-2">    
                <div class="card-header bg-lighter p-1">
                    ${getBySelector('#iptHomeFindAddress').value}
                    <button data-id="${id}" title="Verwijder uit active lagen" class="btn btn-sm borderless icon-btn float-right btnRemoveToolsMutationSelectLayerItem">
                        <span class="fa fa-times" data-id="${id}"></span>
                    </button>
                </div>
            </div>`
            getBySelector('#slcMutationSelectLayer').value = id

            const feature = {
                geometry: {
                    coordinates: routeLocation.getGeometry().getFlatCoordinates(),
                    type: 'Point'
                }
            }
            addToolsMutationSelectLayerFeature(feature)

            getBySelector('#btnMutationSelectLayer').disabled = false
        }
    } else {
        if(window.result) {
            const element = document.querySelector('layer-info-info-item-header[class="active"]')
            let bookmarkPresentationName
            if(element) {
                bookmarkPresentationName = element.dataset.bookmarkPresentationName
            } else {
                bookmarkPresentationName = window.result.mainTabs.find(mainTab => mainTab.features.length > 0)
                if(bookmarkPresentationName) {
                    bookmarkPresentationName = bookmarkPresentationName.BookmarkPresentationID
                }
            }

            if(bookmarkPresentationName) {
                getBySelector('#slcMutationSelectLayer').value = bookmarkPresentationName
                addToolsMutationSelectLayerItem(window.result)
                getBySelector('#btnMutationSelectLayer').disabled = false
            } else {
                toastr.info('Kies een object uit de kaart')
            }
        } else {
            toastr.info('Kies een object uit de kaart')
        }
    }
}

export function mutationGeometryFromGeometry() {
    showElementsBySelector('#divMutationSnapLayer')
}

export function loadMutationSelectOptions() {
    let options = '<option value="">Snap op laag</option>'
    getSnapLayers().map(layer => {
        if(layer && layer.Type === 'WMS') {
            options += `<option value="${layer.ID}">${layer.DisplayName}</option>`
        }
    })
    const element = getBySelector('#slcMutationSnapLayer')
    if(element) {
        element.innerHTML = options
    }

    const slcDrawSnapLayer = getBySelector('#slcDrawSnapLayer')
    if(slcDrawSnapLayer) {
        slcDrawSnapLayer.innerHTML = options
    }
}

export function resetMutation() {

    activeMutation = undefined

    showElementsBySelector('#divCardMutationLayers')
    hideElementsBySelector('#divMutationLayers')
    hideElementsBySelector('#btnShowMutationLayers')
    getBySelector('#divToolsMutationSettings').innerHTML = ``

    $("#slcMutationLayers").val('');
    $('#slcMutationLayers').trigger('change');

    stopDraw(false, false)

    hideElementsBySelector('layer-info-mutation .btnHideInfoMenu')

    checkActiveLayerInfoButtons()
}

export function removeAllDrawings() {

    stopDraw()

    if(window.measurePrintFeatures.length === 0) {
        return
    }

    Swal.fire({
        title: 'Wil je alle tekeningen verwijderen?',
        buttonsStyling: false,
        customClass: {
            confirmButton: 'btn btn-danger',
            cancelButton: 'btn btn-outline-secondary'
        },
        confirmButtonText: 'Ja',
        cancelButtonText: 'Nee',
        showCancelButton: true,
    }).then((result) => {
        if (result.value) {
            clearLayer(geMeasureLayerName(), false)
            getBySelector('#divMeasureDrawings').innerHTML = ''
            window.measurePrintFeatures = []


            checkActiveLayerInfoButtons()

            hideElementsBySelector('layer-info-tools .btnHideInfoMenu')

            hideElementsBySelector('#divToolsMeasureDrawButtons')
            hideElementsBySelector('#divToolsMeasureToggleButtons')
        }
    })
}
